import { render, staticRenderFns } from "./TaskDue.vue?vue&type=template&id=670efc50&"
import script from "./TaskDue.vue?vue&type=script&lang=js&"
export * from "./TaskDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports